import React from 'react';
import { decodePolyline } from '../Util'
import * as d3 from "d3";

import Basemap from '../components/Basemap'
import Legend from '../components/Legend'

import moment from "moment";
import momentDurationFormatSetup from "moment-duration-format";

momentDurationFormatSetup(moment);



class Complete extends React.Component {

	componentDidMount() {
		if (this.props.activity) {
			this.display(this.props.activity,this.props.poster.unit);
		}
	}

	display(activity,unit) {

		d3.select('#path').attr('d','');
		
		d3.select('#pace').attr('d','');
		d3.select('#hr').attr('d','');
		d3.select('#elevationArea').attr('d','');
		d3.select('#elevation').attr('d','');

		var featureCollection = {
			type: "FeatureCollection",
			features: []
		}



		if (activity.map.summary_polyline) {
			var feature = {
				type: "Feature",
				properties: {},
				geometry: {
					type: "LineString",
					//coordinates: decodePolyline(activity.map.summary_polyline).map(function (elt) { return [elt[1], elt[0]] })
					coordinates: decodePolyline(activity.map.polyline).map(function (elt) { return [elt[1], elt[0]] })
				}
			};
			featureCollection.features.push(feature);
		}else{
			return;
		}


		var projection = d3.geoMercator().fitExtent([[this.props.poster.layout.margin, this.props.poster.layout.margin], [this.props.poster.layout.width - this.props.poster.layout.margin, this.props.poster.layout.height - this.props.poster.layout.margin - this.props.poster.legend.height - this.props.poster.legend.spacer - 200]], featureCollection);

		var path = this.path = d3.geoPath()
			.projection(projection);

		d3.select('#path').datum(featureCollection).attr('d', path);



		var chartHeight = 150;
		// set the ranges
		var x = d3.scaleLinear().range([0, this.props.poster.layout.width - this.props.poster.layout.margin * 2 + 10]);
		var y = d3.scaleLinear().range([chartHeight, 0]);
		var yPace = d3.scaleLinear().range([chartHeight / 2 * 0.9, 0]);
		var yHr = d3.scaleLinear().range([chartHeight / 2 * 0.9, 0]);

		// define the area
		var area = d3.area()
			.x(function (d) { return x(d.date); })
			.y0(chartHeight)
			.y1(function (d) { return y(d.close); });

		// define the line
		var valueline = d3.line()
			.x(function (d) { return x(d.date); })
			.y(function (d) { return y(d.close); });

		var offset = this.props.poster.layout.height - this.props.poster.legend.height - this.props.poster.legend.spacer - 200;
		
		if(activity.streams){
			var data = activity.streams.time.data.map((x, i) => {
				var altitude = activity.streams.altitude.data[i]
				if (unit === "mi") {
					altitude = activity.streams.altitude.data[i]*3.28084
				}
				return {
					date: x,
					close: altitude
				}
			})
	
			var paceLine = d3.line().curve(d3.curveBasis)
				.x(function (d) { return x(d.date); })
				.y(function (d, i) { return yPace(d.close); });
	
			var pace = activity.streams.time.data.map((x, i) => {
				//var pace = activity.streams.velocity_smooth.data[i]===0?0:1000/activity.streams.velocity_smooth.data[i]
				var speed = activity.streams.velocity_smooth.data[i] === 0 ? 0 : 3600 * activity.streams.velocity_smooth.data[i] / 1000
				if (unit === "mi") {
					speed = activity.streams.velocity_smooth.data[i] === 0 ? 0 : 3600 * activity.streams.velocity_smooth.data[i] / 1609.34
				}
				return {
					date: x,
					close: speed
				}
			})
			var minPace = d3.min(pace, function (d) { return d.close; });
			var maxPace = d3.max(pace, function (d) { return d.close; });
			yPace.domain([minPace, maxPace]);
	
			var hrLine = d3.line().curve(d3.curveBasis)
				.x(function (d) { return x(d.date); })
				.y(function (d, i) { return yHr(d.close); });
	
			var hr = activity.streams.time.data.map((x, i) => {
				return {
					date: x,
					close: activity.streams.heartrate ? activity.streams.heartrate.data[i] : null
				}
			})
			var minHr = d3.min(hr, function (d) { return d.close; });
			var maxHr = d3.max(hr, function (d) { return d.close; });
			yHr.domain([minHr, maxHr]);
	
			// Scale the range of the data
			x.domain(d3.extent(data, function (d) { return d.date; }));
			var min = d3.min(data, function (d) { return d.close; });
			var max = d3.max(data, function (d) { return d.close; });
			y.domain([min - min / 20, max + max / 20]);
	
			
			// Add the valueline path.
	
			d3.select('#elevationArea')
				.data([data])
				.attr("transform", "translate(40 " + (offset + 20) + ")")
				.attr("d", area);
	
			d3.select('#elevation')
				.datum(data)
				.attr("transform", "translate(40 " + (offset + 20) + ")")
				.attr("d", valueline);
	
			d3.select('#pace')
				.data([pace])
				.attr("transform", "translate(40 " + (offset + 20) + ")")
				.attr("d", paceLine);
	
			d3.select('#hr')
				.datum(hr)
				.attr("transform", "translate(40 " + (offset + chartHeight / 2 + 20) + ")")
				.attr("d", hrLine);
				
			
		}
		
		// Add the X Axis
		d3.select('#xaxis')
		.attr("class", "axis")
		.attr("transform", "translate(40 " + (offset + 20 + chartHeight) + ")")
		.call(d3.axisBottom(x)
			.ticks(6)
			.tickFormat(function (d) {
				return moment.duration(d, 'seconds')
					.format('HH:mm:ss', { trim: true });
			}));

		// Add the Y Axis
		d3.select('#yaxis')
			.attr("class", "axis")
			.attr("transform", "translate(40 " + (offset + 20) + ")")
			.call(d3.axisLeft(y).ticks(6));

		// Add the Y Axis
		d3.select('#yaxisPace')
			.attr("class", "axis")
			.attr("transform", "translate(" + (this.props.poster.layout.width - this.props.poster.layout.margin * 2 + 50) + " " + (offset + 20) + ")")
			.call(d3.axisRight(yPace).ticks(6));

		// Add the Y Axis
		d3.select('#yaxisHr')
			.attr("class", "axis")
			.attr("transform", "translate(" + (this.props.poster.layout.width - this.props.poster.layout.margin * 2 + 50) + " " + (offset + chartHeight / 2 + 20) + ")")
			.call(d3.axisRight(yHr).ticks(6));
	}

	shouldComponentUpdate(nextProps) {
		if (!this.props.activity && nextProps.activity) {
			this.display(nextProps.activity,nextProps.poster.unit);
		}
		if (this.props.activity && nextProps.activity) {
			if(this.props.activity.id===nextProps.activity.id && this.props.poster.unit === nextProps.poster.unit){
				return false;
			}
			this.display(nextProps.activity,nextProps.poster.unit);
		}
		return true;
	}

	render() {
		
		return (
			<g>
				<Basemap activities={this.props.activity?[this.props.activity]:[]} poster={this.props.poster} offset={200}/>
				<defs>
					<marker id="start" markerWidth="6" markerHeight="6" refX="3" refY="3"
							markerUnits="strokeWidth">
						<circle id="extremity" cx="3" cy="3" r="1"
								fill={this.props.poster.style.route.color} stroke={this.props.poster.style.route.color} stroke-width="1"/>
					</marker>
				</defs>
				<path id='path' marker-start='url(#start)' marker-end='url(#start)' stroke-linejoin='round' strokeWidth={this.props.poster.style.route.strokeWidth} fill='none' stroke={this.props.poster.style.route.color} />
				<rect id='textRect' width={this.props.poster.layout.width} height={200} transform={"translate(0 " + (this.props.poster.layout.height - this.props.poster.legend.height - this.props.poster.legend.spacer - 200) + ")"} />
				<g id='xaxis' />
				<g id='yaxis' />
				<g id='yaxisPace' />
				<g id='yaxisHr' />
				<path id='elevationArea' fill='darkgrey' opacity={0.2} />
				<path id='elevation' strokeWidth='1' fill='none' stroke='darkgrey' />
				<path id='pace' strokeWidth='1' fill='none' stroke={this.props.poster.style.route.color} />
				<path id='hr' strokeWidth='1' fill='none' stroke={this.props.poster.style.route.color} />

				<Legend/>
			</g>

		)
	}
}

export default Complete;


// WEBPACK FOOTER //
// ./src/components/Complete.js